// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/logo192.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
    background-color: #d8dbec;
    color: #333;
    text-align: center;
    padding: 15px 30px;
    font-size: 24px;
    font-weight: 600;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    font-family: 'Poppins', sans-serif;
}

.app-header img {
    height: 40px;
    width: auto;
}

.app-header span {
    color: #0056FF;
    text-align: center;
    letter-spacing: 0.5px;
}

/* App version badge (left corner) */
.app-version {
    position: absolute;
    left: 30px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #2f4fb5;
    background: #eef3fd;
    padding: 4px 8px;
    border-radius: 12px;
    border: 1px solid #d7e2ff;
    font-weight: 700;
    font-family: 'Poppins', sans-serif;
}

.user-guide-link {
    position: absolute;
    padding-right: 50px;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #0056FF;
    font-size: 14px;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.1;
    text-decoration: underline;
}

.user-guide-link span {
    display: block;
}

.user-guide-link:hover {
    text-decoration: none;
}

/* Hide header when printing and show a custom print header */
@media print {
    .app-header {
        display: none !important;
    }

    body::before {
        content: "";
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;
        position: relative;
        background-color: #4e67f5;
        color: #333;
        text-align: center;
        padding: 15px 30px;
        font-size: 24px;
        font-weight: 600;
        width: 100%;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        font-family: 'Poppins', sans-serif;
    }

    body::before img {
        height: 40px;
        width: auto;
        content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }

    body::before span {
        color: #0056FF;
        content: "Biomark - Biomarker Analysis Tool";
        text-align: center;
        letter-spacing: 0.5px;
    }
}


  `, "",{"version":3,"sources":["webpack://./src/css/step0-header.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,6DAA6D;AAC7D;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,kBAAkB;QAClB,yBAAyB;QACzB,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,qCAAqC;QACrC,kCAAkC;IACtC;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,gDAAwC;IAC5C;;IAEA;QACI,cAAc;QACd,4CAA4C;QAC5C,kBAAkB;QAClB,qBAAqB;IACzB;AACJ","sourcesContent":[".app-header {\n    background-color: #d8dbec;\n    color: #333;\n    text-align: center;\n    padding: 15px 30px;\n    font-size: 24px;\n    font-weight: 600;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 1000;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 15px;\n    font-family: 'Poppins', sans-serif;\n}\n\n.app-header img {\n    height: 40px;\n    width: auto;\n}\n\n.app-header span {\n    color: #0056FF;\n    text-align: center;\n    letter-spacing: 0.5px;\n}\n\n/* App version badge (left corner) */\n.app-version {\n    position: absolute;\n    left: 30px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 12px;\n    color: #2f4fb5;\n    background: #eef3fd;\n    padding: 4px 8px;\n    border-radius: 12px;\n    border: 1px solid #d7e2ff;\n    font-weight: 700;\n    font-family: 'Poppins', sans-serif;\n}\n\n.user-guide-link {\n    position: absolute;\n    padding-right: 50px;\n    right: 30px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #0056FF;\n    font-size: 14px;\n    cursor: pointer;\n    font-family: 'Poppins', sans-serif;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    line-height: 1.1;\n    text-decoration: underline;\n}\n\n.user-guide-link span {\n    display: block;\n}\n\n.user-guide-link:hover {\n    text-decoration: none;\n}\n\n/* Hide header when printing and show a custom print header */\n@media print {\n    .app-header {\n        display: none !important;\n    }\n\n    body::before {\n        content: \"\";\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 15px;\n        position: relative;\n        background-color: #4e67f5;\n        color: #333;\n        text-align: center;\n        padding: 15px 30px;\n        font-size: 24px;\n        font-weight: 600;\n        width: 100%;\n        box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n        font-family: 'Poppins', sans-serif;\n    }\n\n    body::before img {\n        height: 40px;\n        width: auto;\n        content: url('../../public/logo192.png');\n    }\n\n    body::before span {\n        color: #0056FF;\n        content: \"Biomark - Biomarker Analysis Tool\";\n        text-align: center;\n        letter-spacing: 0.5px;\n    }\n}\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
